.layoutMain {
  // default size
  width: 100%;
  background-color: transparent;

  // default positioning - duplicate
  position: relative;
  z-index: 0;
  max-width: var(--max-width);

  // default padding and margin
  padding: 0;
  margin-left: auto;
  margin-right: auto;

  // default alignment
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  overflow-y: auto;
  overflow-x: hidden;

  > section {
    width: 100%;

    &:not(:last-child) {
      margin-bottom: var(--layout-large-margin);
    }

    > *:not(:last-child) {
      margin-bottom: var(--layout-medium-margin);
    }
  }

  // footer modes

  &.auto-footer {
    margin-bottom: var(--layout-footer);
  }

  &.none {
    margin-bottom: 0;
    overflow-y: scroll;
    padding-bottom: max(calc(env(safe-area-inset-bottom) + 4px), 0);
  }
}
